import moment from 'moment';
import GET_MOVIE_LIST from 'src/queries/getMovieList';
import GET_USER_PROFILE from 'src/queries/getUserProfile';
import getLocalUser from 'src/user/getLocalUser';

const deleteMovieFromListUpdate = ({ userProfile, filter = null }) => (
  cache,
  { data: { deleteMovieFromList } }
) => {
  const userProfileData = cache.readQuery({
    query: GET_USER_PROFILE,
    variables: { id: userProfile.id, userToken: getLocalUser().token },
  }) as any;
  delete userProfileData.userProfile[deleteMovieFromList.movieListType].items[
    deleteMovieFromList.movieId
  ];

  cache.writeQuery({
    data: userProfileData,
    query: GET_USER_PROFILE,
    variables: { id: userProfile.id, userToken: getLocalUser().token },
  });

  if (filter) {
    const movieListId = userProfile[deleteMovieFromList.movieListType].id;
    try {
      const movieListData = cache.readQuery({
        query: GET_MOVIE_LIST,
        variables: {
          filter,
          id: movieListId,
          userUtcOffset: `${moment().utcOffset()}`,
        },
      }) as any;
      movieListData.movieList.items = movieListData.movieList.items.filter(
        (i) => i.id !== deleteMovieFromList.movieId
      );

      cache.writeQuery({
        data: movieListData,
        query: GET_MOVIE_LIST,
        variables: {
          filter,
          id: movieListId,
          userUtcOffset: `${moment().utcOffset()}`,
        },
      });
    } catch (error) {
      // Movie List not found in cache
    }
  }
};

export default deleteMovieFromListUpdate;



// WEBPACK FOOTER //
// ./src/cache/deleteMovieFromList.ts